module.exports = __webpack_public_path__ + "img/lecturer_pic.65b34526.svg";